// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2CDYn","description":"PatientConsentPreview_description__331cm"};